const TOKEN_KEY = 'babysitter_token';
const USER_KEY = 'babysitter_user';

const readFromStorage = (key) => {
  const localValue = localStorage.getItem(key);
  if (localValue) return localValue;
  return sessionStorage.getItem(key);
};

const clearStorage = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
};

export const saveAuth = (token, user, options = {}) => {
  const { rememberMe = true } = options;
  clearStorage();
  const storage = rememberMe ? localStorage : sessionStorage;
  storage.setItem(TOKEN_KEY, token);
  storage.setItem(USER_KEY, JSON.stringify(user));
};

export const getAuthToken = () => {
  return readFromStorage(TOKEN_KEY);
};

export const getUser = () => {
  const userStr = readFromStorage(USER_KEY);
  if (!userStr) return null;
  try {
    return JSON.parse(userStr);
  } catch {
    return null;
  }
};

export const logout = () => {
  clearStorage();
};

export const isAuthenticated = () => {
  return !!getAuthToken() && !!getUser();
};

